import { Col, Row } from "antd";
import moment from 'moment';
import { GITHUB, LINKEDIN } from '../App.constant';
import GithubSVG from '../assets/images/github.svg';
import LinkedinSVG from '../assets/images/linkedin.svg';
import stateWrapper from '../containers/provider';

const FooterBarMobile = props => {
    const year = moment().format('YYYY');
  return (
    <div className="footermobile">
      <Row align="middle" justify="space-between" >
        {/* Branding */}
        <Col span={8}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ fontSize: 13, fontWeight: "bold", color: "#FFF", fontFamily: "'Montserrat', sans-serif" }}>Vicks</div>
            <span style={{ color: "gray", fontSize: 10 }}>•</span>
            <div style={{ fontSize: 10, color: "gray", fontFamily: "'Montserrat', sans-serif" }}>@{year}</div>
          </div>
        </Col>
        
        
        {/* Social Icons */}
        <Col span={8}>
          <div style={{ display: "flex", alignItems: "right", gap: 8}}>
            <a target="_blank" rel="noopener noreferrer" href={LINKEDIN} style={{ display: "flex", alignItems: "center" }}>
              <img src={LinkedinSVG} style={{ width: 16, height: 16, opacity: 0.8 }} alt="LinkedIn" />
            </a>
            <a target="_blank" rel="noopener noreferrer" href={GITHUB} styleth={{ display: "flex", alignItems: "center" }}>
              <img src={GithubSVG} style={{ width: 16, height: 16, opacity: 0.8 }} alt="GitHub" />
            </a>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default stateWrapper(FooterBarMobile);
